export default "__VITE_ASSET__1aeda7df__"